/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantHealthStats } from './TenantHealthStats';
import {
    TenantHealthStatsFromJSON,
    TenantHealthStatsFromJSONTyped,
    TenantHealthStatsToJSON,
} from './TenantHealthStats';

/**
 * 
 * @export
 * @interface TenantHealthHistory
 */
export interface TenantHealthHistory {
    /**
     * 
     * @type {Array<TenantHealthStats>}
     * @memberof TenantHealthHistory
     */
    snapshots?: Array<TenantHealthStats>;
}

/**
 * Check if a given object implements the TenantHealthHistory interface.
 */
export function instanceOfTenantHealthHistory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthHistoryFromJSON(json: any): TenantHealthHistory {
    return TenantHealthHistoryFromJSONTyped(json, false);
}

export function TenantHealthHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'snapshots': !exists(json, 'snapshots') ? undefined : ((json['snapshots'] as Array<any>).map(TenantHealthStatsFromJSON)),
    };
}

export function TenantHealthHistoryToJSON(value?: TenantHealthHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'snapshots': value.snapshots === undefined ? undefined : ((value.snapshots as Array<any>).map(TenantHealthStatsToJSON)),
    };
}

